import { jsx } from "react/jsx-runtime";
import { RequiredIndicator } from "@wix/ambassador-forms-v4-form/types";
import { Text } from "@wix/wix-ui-tpa/cssVars";
import { useMemo } from "react";
import { useConfig } from "../../contexts/config-context.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { formatCurrency } from "../../utils/format-currency.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
import { classes } from "./fixed-payment-field-wut.st.css";
const FixedPaymentFieldWUT = ({
  id,
  label,
  hideLabel = false,
  required = false,
  error,
  description,
  validation,
  FieldLayout,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, descriptionId } = useFieldAttributes(
    id,
    error,
    description
  );
  const { currency, regionalFormat } = useConfig();
  const paymentValidation = useMemo(
    () => validation?.predefined?.paymentOptions?.products?.[0],
    [validation]
  );
  const fixedPaymentValue = paymentValidation?.fixedPriceOptions?.price;
  const formattedValue = formatCurrency({
    amount: fixedPaymentValue,
    currency: currency?.code,
    locale: regionalFormat
  });
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType: RequiredIndicator.NONE
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange: () => {
          },
          value: null
        }
      ) : /* @__PURE__ */ jsx(
        Text,
        {
          className: classes.text,
          id: inputId,
          "data-hook": "fixed-payment-value",
          "aria-hidden": "false",
          children: formattedValue
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
    }
  );
};
export {
  FixedPaymentFieldWUT
};
//# sourceMappingURL=fixed-payment-field-wut.js.map
